export default [{
        path: '/401',
        name: 'error_401',
        meta: {
            hideInMenu: true,
        },
        component: () =>
            import('_v/error-page/401.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true,
        },
        component: () =>
            import('_v/error-page/500.vue')
    },
    {
        path: '*',
        name: 'error_404',
        meta: {
            hideInMenu: true,
        },
        component: () =>
            import('_v/error-page/404.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            hideInMenu: true,
        },
        component: () =>
            import('_v/login/login')
    },
]